module.exports = __webpack_public_path__ + "static/media/pause.efe8264f.svg";